import '../../assets/index47.css';var gt = Object.defineProperty, bt = Object.defineProperties;
var _t = Object.getOwnPropertyDescriptors;
var R = Object.getOwnPropertySymbols;
var ce = Object.prototype.hasOwnProperty, ue = Object.prototype.propertyIsEnumerable;
var pe = (e, r, t) => r in e ? gt(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, u = (e, r) => {
  for (var t in r || (r = {}))
    ce.call(r, t) && pe(e, t, r[t]);
  if (R)
    for (var t of R(r))
      ue.call(r, t) && pe(e, t, r[t]);
  return e;
}, h = (e, r) => bt(e, _t(r));
var W = (e, r) => {
  var t = {};
  for (var s in e)
    ce.call(e, s) && r.indexOf(s) < 0 && (t[s] = e[s]);
  if (e != null && R)
    for (var s of R(e))
      r.indexOf(s) < 0 && ue.call(e, s) && (t[s] = e[s]);
  return t;
};
import { jsx as p, jsxs as B, Fragment as be } from "react/jsx-runtime";
import yt, { useRef as wt, useEffect as St } from "react";
import { ErrorMessage as vt } from "../../molecules/ErrorMessage/index.js";
import { Label as Ct } from "../Label/index.js";
import { u as It } from "../../use-resolved-styles-api-D-aL_8KF.js";
import { u as Ot } from "../../use-styles-DToiHEa6.js";
import { c as Dt, f as Tt, u as Pt, e as xt } from "../../factory-ueRxoNOV.js";
import { C as f, c as de, g as Et, a as Lt, u as Vt } from "../../Combobox-5HUj9q7L.js";
import { C as At } from "../../CheckIcon-DkmKiN6y.js";
import { S as $t } from "../../ScrollArea-BFbb1tLv.js";
import { I as kt } from "../../InputBase-Cabx1d9o.js";
import { P as fe } from "../../Pill-s4XaUkmY.js";
import { P as me } from "../../PillsInput-yGVpK8NH.js";
import { u as Bt } from "../../use-id-D2tGiO9x.js";
import { u as Nt } from "../../use-merged-ref-n551Tfbr.js";
import { u as he } from "../../use-uncontrolled-BT_j5D2R.js";
function V(e) {
  return "group" in e;
}
function _e({
  options: e,
  search: r,
  limit: t
}) {
  const s = r.trim().toLowerCase(), n = [];
  for (let a = 0; a < e.length; a += 1) {
    const l = e[a];
    if (n.length === t)
      return n;
    V(l) && n.push({
      group: l.group,
      items: _e({
        options: l.items,
        search: r,
        limit: t - n.length
      })
    }), V(l) || l.label.toLowerCase().includes(s) && n.push(l);
  }
  return n;
}
function Ft(e) {
  if (e.length === 0)
    return !0;
  for (const r of e)
    if (!("group" in r) || r.items.length > 0)
      return !1;
  return !0;
}
function ye(e, r = /* @__PURE__ */ new Set()) {
  if (Array.isArray(e))
    for (const t of e)
      if (V(t))
        ye(t.items, r);
      else {
        if (typeof t.value == "undefined")
          throw new Error("[@mantine/core] Each option must have value property");
        if (typeof t.value != "string")
          throw new Error(
            `[@mantine/core] Option value must be a string, other data formats are not supported, got ${typeof t.value}`
          );
        if (r.has(t.value))
          throw new Error(
            `[@mantine/core] Duplicate options are not supported. Option with value "${t.value}" was provided more than once`
          );
        r.add(t.value);
      }
}
function zt(e, r) {
  return Array.isArray(e) ? e.includes(r) : e === r;
}
function we({
  data: e,
  withCheckIcon: r,
  value: t,
  checkIconPosition: s,
  unstyled: n,
  renderOption: a
}) {
  if (!V(e)) {
    const i = zt(t, e.value), v = r && i && /* @__PURE__ */ p(At, { className: de.optionsDropdownCheckIcon }), y = /* @__PURE__ */ B(be, { children: [
      s === "left" && v,
      /* @__PURE__ */ p("span", { children: e.label }),
      s === "right" && v
    ] });
    return /* @__PURE__ */ p(
      f.Option,
      {
        value: e.value,
        disabled: e.disabled,
        className: Dt({ [de.optionsDropdownOption]: !n }),
        "data-reverse": s === "right" || void 0,
        "data-checked": i || void 0,
        "aria-selected": i,
        active: i,
        children: typeof a == "function" ? a({ option: e, checked: i }) : y
      }
    );
  }
  const l = e.items.map((i) => /* @__PURE__ */ p(
    we,
    {
      data: i,
      value: t,
      unstyled: n,
      withCheckIcon: r,
      checkIconPosition: s,
      renderOption: a
    },
    i.value
  ));
  return /* @__PURE__ */ p(f.Group, { label: e.group, children: l });
}
function Rt({
  data: e,
  hidden: r,
  hiddenWhenEmpty: t,
  filter: s,
  search: n,
  limit: a,
  maxDropdownHeight: l,
  withScrollArea: i = !0,
  filterOptions: v = !0,
  withCheckIcon: y = !1,
  value: A,
  checkIconPosition: m,
  nothingFoundMessage: T,
  unstyled: P,
  labelId: g,
  renderOption: C,
  scrollAreaProps: $,
  "aria-label": j
}) {
  ye(e);
  const N = typeof n == "string" ? (s || _e)({
    options: e,
    search: v ? n : "",
    limit: a != null ? a : 1 / 0
  }) : e, F = Ft(N), z = N.map((w) => /* @__PURE__ */ p(
    we,
    {
      data: w,
      withCheckIcon: y,
      value: A,
      checkIconPosition: m,
      unstyled: P,
      renderOption: C
    },
    V(w) ? w.group : w.value
  ));
  return /* @__PURE__ */ p(f.Dropdown, { hidden: r || t && F, "data-composed": !0, children: /* @__PURE__ */ B(f.Options, { labelledBy: g, "aria-label": j, children: [
    i ? /* @__PURE__ */ p(
      $t.Autosize,
      h(u({
        mah: l != null ? l : 220,
        type: "scroll",
        scrollbarSize: "var(--combobox-padding)",
        offsetScrollbars: "y"
      }, $), {
        children: z
      })
    ) : z,
    F && T && /* @__PURE__ */ p(f.Empty, { children: T })
  ] }) });
}
function Wt({ data: e, value: r }) {
  const t = r.map((n) => n.trim().toLowerCase());
  return e.reduce((n, a) => (V(a) ? n.push({
    group: a.group,
    items: a.items.filter(
      (l) => t.indexOf(l.label.toLowerCase().trim()) === -1
    )
  }) : t.indexOf(a.label.toLowerCase().trim()) === -1 && n.push(a), n), []);
}
function jt(e, r) {
  return e ? r.split(new RegExp(`[${e.join("")}]`)).map((t) => t.trim()).filter((t) => t !== "") : [r];
}
function ge({
  splitChars: e,
  allowDuplicates: r,
  maxTags: t,
  value: s,
  currentTags: n
}) {
  const a = jt(e, s), l = r ? [...n, ...a] : [.../* @__PURE__ */ new Set([...n, ...a])];
  return t ? l.slice(0, t) : l;
}
const qt = {
  maxTags: 1 / 0,
  allowDuplicates: !1,
  acceptValueOnBlur: !0,
  splitChars: [","],
  hiddenInputValuesDivider: ","
}, X = Tt((e, r) => {
  const t = Pt("TagsInput", qt, e), le = t, {
    classNames: s,
    className: n,
    style: a,
    styles: l,
    unstyled: i,
    vars: v,
    size: y,
    value: A,
    defaultValue: m,
    onChange: T,
    onKeyDown: P,
    maxTags: g,
    allowDuplicates: C,
    onDuplicate: $,
    variant: j,
    data: Z,
    dropdownOpened: N,
    defaultDropdownOpened: F,
    onDropdownOpen: z,
    onDropdownClose: w,
    selectFirstOptionOnChange: H,
    onOptionSubmit: x,
    comboboxProps: Se,
    filter: ve,
    limit: Ce,
    withScrollArea: Ie,
    maxDropdownHeight: Oe,
    searchValue: De,
    defaultSearchValue: Te,
    onSearchChange: Pe,
    readOnly: k,
    disabled: I,
    splitChars: q,
    onFocus: G,
    onBlur: K,
    onPaste: M,
    radius: xe,
    rightSection: Ee,
    rightSectionWidth: Le,
    rightSectionPointerEvents: Ve,
    rightSectionProps: Ae,
    leftSection: $e,
    leftSectionWidth: ke,
    leftSectionPointerEvents: Be,
    leftSectionProps: Ne,
    inputContainer: Fe,
    inputWrapperOrder: ze,
    withAsterisk: Re,
    required: ee,
    labelProps: We,
    descriptionProps: je,
    errorProps: qe,
    wrapperProps: Ge,
    description: Ke,
    label: U,
    error: Me,
    withErrorStyles: Ue,
    name: Ye,
    form: Je,
    id: Qe,
    clearable: Xe,
    clearButtonProps: Ze,
    hiddenInputProps: He,
    hiddenInputValuesDivider: et,
    mod: tt,
    renderOption: rt,
    onRemove: E,
    onClear: Y,
    scrollAreaProps: ot,
    acceptValueOnBlur: st
  } = le, te = W(le, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "size",
    "value",
    "defaultValue",
    "onChange",
    "onKeyDown",
    "maxTags",
    "allowDuplicates",
    "onDuplicate",
    "variant",
    "data",
    "dropdownOpened",
    "defaultDropdownOpened",
    "onDropdownOpen",
    "onDropdownClose",
    "selectFirstOptionOnChange",
    "onOptionSubmit",
    "comboboxProps",
    "filter",
    "limit",
    "withScrollArea",
    "maxDropdownHeight",
    "searchValue",
    "defaultSearchValue",
    "onSearchChange",
    "readOnly",
    "disabled",
    "splitChars",
    "onFocus",
    "onBlur",
    "onPaste",
    "radius",
    "rightSection",
    "rightSectionWidth",
    "rightSectionPointerEvents",
    "rightSectionProps",
    "leftSection",
    "leftSectionWidth",
    "leftSectionPointerEvents",
    "leftSectionProps",
    "inputContainer",
    "inputWrapperOrder",
    "withAsterisk",
    "required",
    "labelProps",
    "descriptionProps",
    "errorProps",
    "wrapperProps",
    "description",
    "label",
    "error",
    "withErrorStyles",
    "name",
    "form",
    "id",
    "clearable",
    "clearButtonProps",
    "hiddenInputProps",
    "hiddenInputValuesDivider",
    "mod",
    "renderOption",
    "onRemove",
    "onClear",
    "scrollAreaProps",
    "acceptValueOnBlur"
  ]), J = Bt(Qe), re = Et(Z), nt = Lt(re), oe = wt(null), at = Nt(oe, r), b = Vt({
    opened: N,
    defaultOpened: F,
    onDropdownOpen: z,
    onDropdownClose: () => {
      w == null || w(), b.resetSelectedOption();
    }
  }), {
    styleProps: lt,
    rest: ht
  } = xt(te), ie = ht, { type: Zt, autoComplete: it } = ie, pt = W(ie, ["type", "autoComplete"]), [c, O] = he({
    value: A,
    defaultValue: m,
    finalValue: [],
    onChange: T
  }), [D, ct] = he({
    value: De,
    defaultValue: Te,
    finalValue: "",
    onChange: Pe
  }), L = (o) => {
    ct(o), b.resetSelectedOption();
  }, Q = Ot({
    name: "TagsInput",
    classes: {},
    props: t,
    classNames: s,
    styles: l,
    unstyled: i
  }), { resolvedClassNames: se, resolvedStyles: ne } = It({
    props: t,
    styles: l,
    classNames: s
  }), ae = (o) => {
    const d = c.some((S) => S.toLowerCase() === o.toLowerCase());
    d && ($ == null || $(o)), (!d || d && C) && c.length < g && (x == null || x(o), L(""), o.length > 0 && O([...c, o]));
  }, ut = (o) => {
    if (P == null || P(o), o.isPropagationStopped())
      return;
    const d = D.trim(), { length: S } = d;
    if (q.includes(o.key) && S > 0 && (O(
      ge({
        splitChars: q,
        allowDuplicates: C,
        maxTags: g,
        value: D,
        currentTags: c
      })
    ), L(""), o.preventDefault()), o.key === "Enter" && S > 0 && !o.nativeEvent.isComposing) {
      if (o.preventDefault(), !!document.querySelector(
        `#${b.listId} [data-combobox-option][data-combobox-selected]`
      ))
        return;
      ae(d);
    }
    o.key === "Backspace" && S === 0 && c.length > 0 && !o.nativeEvent.isComposing && (E == null || E(c[c.length - 1]), O(c.slice(0, c.length - 1)));
  }, dt = (o) => {
    if (M == null || M(o), o.preventDefault(), o.clipboardData) {
      const d = o.clipboardData.getData("text/plain");
      O(
        ge({
          splitChars: q,
          allowDuplicates: C,
          maxTags: g,
          value: `${D}${d}`,
          currentTags: c
        })
      ), L("");
    }
  }, ft = c.map((o, d) => /* @__PURE__ */ p(
    fe,
    h(u({
      withRemoveButton: !k,
      onRemove: () => {
        const S = c.slice();
        S.splice(d, 1), O(S), E == null || E(o);
      },
      unstyled: i,
      disabled: I
    }, Q("pill")), {
      children: o
    }),
    `${o}-${d}`
  ));
  St(() => {
    H && b.selectFirstOption();
  }, [H, c, D]);
  const mt = /* @__PURE__ */ p(
    f.ClearButton,
    h(u({}, Ze), {
      onClear: () => {
        var o;
        O([]), L(""), (o = oe.current) == null || o.focus(), b.openDropdown(), Y == null || Y();
      }
    })
  );
  return /* @__PURE__ */ B(be, { children: [
    /* @__PURE__ */ B(
      f,
      h(u({
        store: b,
        classNames: se,
        styles: ne,
        unstyled: i,
        size: y,
        readOnly: k,
        __staticSelector: "TagsInput",
        onOptionSubmit: (o) => {
          x == null || x(o), L(""), c.length < g && O([...c, nt[o].label]), b.resetSelectedOption();
        }
      }, Se), {
        children: [
          /* @__PURE__ */ p(f.DropdownTarget, { children: /* @__PURE__ */ p(
            me,
            h(u({}, lt), {
              __staticSelector: "TagsInput",
              classNames: se,
              styles: ne,
              unstyled: i,
              size: y,
              className: n,
              style: a,
              variant: j,
              disabled: I,
              radius: xe,
              rightSection: Ee,
              __clearSection: mt,
              __clearable: Xe && c.length > 0 && !I && !k,
              rightSectionWidth: Le,
              rightSectionPointerEvents: Ve,
              rightSectionProps: Ae,
              leftSection: $e,
              leftSectionWidth: ke,
              leftSectionPointerEvents: Be,
              leftSectionProps: Ne,
              inputContainer: Fe,
              inputWrapperOrder: ze,
              withAsterisk: Re,
              required: ee,
              labelProps: We,
              descriptionProps: je,
              errorProps: qe,
              wrapperProps: Ge,
              description: Ke,
              label: U,
              error: Me,
              withErrorStyles: Ue,
              __stylesApiProps: h(u({}, t), { multiline: !0 }),
              id: J,
              mod: tt,
              children: /* @__PURE__ */ B(fe.Group, h(u({ disabled: I, unstyled: i }, Q("pillsList")), { children: [
                ft,
                /* @__PURE__ */ p(f.EventsTarget, { autoComplete: it, children: /* @__PURE__ */ p(
                  me.Field,
                  h(u(h(u({}, pt), {
                    ref: at
                  }), Q("inputField")), {
                    unstyled: i,
                    onKeyDown: ut,
                    onFocus: (o) => {
                      G == null || G(o), b.openDropdown();
                    },
                    onBlur: (o) => {
                      K == null || K(o), st && ae(D), b.closeDropdown();
                    },
                    onPaste: dt,
                    value: D,
                    onChange: (o) => L(o.currentTarget.value),
                    required: ee && c.length === 0,
                    disabled: I,
                    readOnly: k,
                    id: J
                  })
                ) })
              ] }))
            })
          ) }),
          /* @__PURE__ */ p(
            Rt,
            {
              data: Wt({ data: re, value: c }),
              hidden: k || I,
              filter: ve,
              search: D,
              limit: Ce,
              hiddenWhenEmpty: !0,
              withScrollArea: Ie,
              maxDropdownHeight: Oe,
              unstyled: i,
              labelId: U ? `${J}-label` : void 0,
              "aria-label": U ? void 0 : te["aria-label"],
              renderOption: rt,
              scrollAreaProps: ot
            }
          )
        ]
      })
    ),
    /* @__PURE__ */ p(
      f.HiddenInput,
      u({
        name: Ye,
        form: Je,
        value: c,
        valuesDivider: et,
        disabled: I
      }, He)
    )
  ] });
});
X.classes = u(u({}, kt.classes), f.classes);
X.displayName = "@mantine/core/TagsInput";
const Gt = "TagsInput-module__root___xYgjh", Kt = "TagsInput-module__wrapper___l2qK9", Mt = "TagsInput-module__input___neoeg", Ut = "TagsInput-module__pillsList___O-m75", Yt = "TagsInput-module__label___7fDrn", Jt = "TagsInput-module__error___ffBSx", Qt = "TagsInput-module__description___4z4zD", _ = {
  root: Gt,
  wrapper: Kt,
  input: Mt,
  pillsList: Ut,
  label: Yt,
  error: Jt,
  description: Qt
}, Xt = yt.forwardRef((P, T) => {
  var g = P, {
    error: e,
    rightSection: r,
    label: t,
    withAsterisk: s,
    tags: n = [],
    onTagsChange: a,
    maxTags: l,
    allowDuplicates: i = !1,
    splitChars: v = [","],
    className: y,
    width: A
  } = g, m = W(g, [
    "error",
    "rightSection",
    "label",
    "withAsterisk",
    "tags",
    "onTagsChange",
    "maxTags",
    "allowDuplicates",
    "splitChars",
    "className",
    "width"
  ]);
  const C = typeof t == "string" ? /* @__PURE__ */ p(Ct, { label: t, withAsterisk: s }) : t;
  return /* @__PURE__ */ p(
    X,
    {
      "data-plum-id": m["data-plum-id"],
      classNames: {
        root: _.root,
        input: _.input,
        wrapper: _.wrapper,
        label: _.label,
        section: _.section,
        error: _.error,
        description: _.description,
        pillsList: _.pillsList,
        pill: _.pill
      },
      inputWrapperOrder: ["label", "input", e ? "error" : "description"],
      error: e && /* @__PURE__ */ p(vt, { error: e }),
      label: C,
      value: n,
      onChange: a,
      maxTags: l,
      allowDuplicates: i,
      splitChars: v,
      disabled: m.disabled,
      placeholder: m.placeholder,
      description: m.description,
      leftSection: m.leftSection,
      rightSection: r,
      "data-variant": "tag-input",
      clearable: m.clearable,
      ref: T,
      className: y,
      style: { width: A }
    }
  );
});
Xt.displayName = "TagsInput";
export {
  Xt as TagsInput
};
